import { render, staticRenderFns } from "./MessageNoticeDialog.vue?vue&type=template&id=69701760&"
import script from "./MessageNoticeDialog.vue?vue&type=script&lang=js&"
export * from "./MessageNoticeDialog.vue?vue&type=script&lang=js&"
import style0 from "./MessageNoticeDialog.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports